var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C5.50147 0 3.46875 2.03282 3.46875 4.53148V7.25037H2.5625C2.0818 7.25037 1.62078 7.44134 1.28087 7.78127C0.940959 8.1212 0.75 8.58224 0.75 9.06297V16.3133C0.75 16.7941 0.940959 17.2551 1.28087 17.595C1.62078 17.935 2.0818 18.1259 2.5625 18.1259H13.4375C13.9182 18.1259 14.3792 17.935 14.7191 17.595C15.059 17.2551 15.25 16.7941 15.25 16.3133V9.06297C15.25 8.58224 15.059 8.1212 14.7191 7.78127C14.3792 7.44134 13.9182 7.25037 13.4375 7.25037H12.5312V4.53148C12.5312 2.03282 10.4985 0 8 0ZM5.28125 4.53148C5.28125 3.03247 6.50106 1.81259 8 1.81259C9.49894 1.81259 10.7188 3.03247 10.7188 4.53148V7.25037H5.28125V4.53148ZM8.90625 14.2497V16.3133H7.09375V14.2497C6.77691 14.0683 6.5225 13.795 6.36406 13.4661C6.20563 13.1371 6.1506 12.7679 6.20624 12.407C6.26189 12.0461 6.42559 11.7106 6.67576 11.4447C6.92592 11.1787 7.25082 10.9948 7.60759 10.9172C7.8726 10.8587 8.14737 10.8603 8.41166 10.922C8.67595 10.9838 8.923 11.1041 9.13461 11.274C9.34622 11.444 9.51698 11.6593 9.63431 11.904C9.75163 12.1488 9.81253 12.4167 9.8125 12.6882C9.81198 13.0051 9.72794 13.3164 9.56884 13.5905C9.40974 13.8646 9.1812 14.092 8.90625 14.2497Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLock);
export default __webpack_public_path__ + "static/media/ico-lock.23782fa8dfc17f8f775c52c4cef812f3.svg";
export { ForwardRef as ReactComponent };